import { LineChart, Line, CartesianGrid, XAxis, YAxis } from 'recharts';
import React from "react";
const data = [
    {name: 'A', uv: 256, amt: 10},
    {name: 'B', uv: 283, amt: 10},
    {name: 'C', uv: 304, amt: 10},
    {name: 'D', uv: 273, amt: 10},
];

class MQ4Graph extends React.Component {
    render() {
        return (
            <LineChart width={160} height={150} data={data}>
                <Line type="monotone" dataKey="uv" stroke="#228AAA" strokeWidth="5"/>
                <CartesianGrid stroke="#ccc" />
                <XAxis label="MQ4" dy={50}/>
                <YAxis />
            </LineChart>
        );
    }
}


export default MQ4Graph;
